import { atom } from "recoil";
import { IUserEmailRestrictions } from "../generated/Api";

export const UserEmailRestrictionsAtom = atom<IUserEmailRestrictions>({
  key: "UserEmailRestrictionsAtom",
  default: null,
});
